import gql from 'graphql-tag';

export const MarkAllCommentsAsReadMutation = gql`
	mutation MarkAllCommentsAsReadMutation(
		$cloudId: ID!
		$contentId: String!
		$readView: ConfluenceViewState
	) {
		confluence_markAllCommentsAsRead(
			cloudId: $cloudId
			input: { contentId: $contentId, readView: $readView }
		) {
			success
			errors {
				message
			}
		}
	}
`;
